<template>
  <div ref="chart">
    <Chart :extendData="extendData" :height="height" :id="id" :option="option" :width="width"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';
import echarts from 'echarts'

export default {
  name: "temperatureChart",
  components: {Chart},
  props: {
    data: {},
    scope: Array,
    max: null,
    extendData: null,
  },
  data() {
    return {
      id: "lineChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption() {
      var kd = [];        // 刻度
      var Gradient = [];  // 存放颜色的数组
      let mercuryColor; //底圆颜色

      // 刻度使用柱状图模拟，短设置3，长的设置5；构造一个数据
      for (let i = 0, len = 130; i <= len; i++) {
        if (i > 100 || i < 30) {
          kd.push('0')
        } else {
          if (i % 10 === 0) {
            kd.push('-30');
          } else {
            kd.push('-20');
          }
        }
      }
      //中间线的渐变色和文本内容
      if (this.data >= this.scope[0]) {
        mercuryColor = '#E4D225'
        Gradient.push({
          offset: 0,
          color: '#E4D225'
        }, {
          offset: 1,
          color: '#E01F28'
        })
      }
      else if (this.data <= this.scope[1]) {
        mercuryColor = '#E01F28'
        Gradient.push({
          offset: 1,
          color: '#E01F28'
        })
      }
      else {
        mercuryColor = '#93FE94'
        Gradient.push({
          offset: 0,
          color: '#93FE94'
        }, {
          offset: 1,
          color: '#E4D225'
        })
      }

      let borderColor = '#6192C5';
      this.option = {
        title: {
          text: '温度计',
          show: false
        },
        yAxis: [{
          show: false,
          min: 0,
          max: 130,
        }, {
          show: false,
          data: [],
          min: 0,
          max: 130,
        }],
        xAxis: [{
          show: false,
          data: []
        }, {
          show: false,
          data: []
        }, {
          show: false,
          data: []
        }, {
          show: false,
          min: -110,
          max: 100,

        }],
        series: [{
          animation:false,
          name: '条',
          type: 'bar',
          // 对应上面XAxis的第一个对象配置
          xAxisIndex: 0,
          data: [{value: this.data + 30, name: '温度', unit: '℃'}],
          barWidth: 4,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, Gradient)
            }
          },
          label: {
            normal: {
              show: false,
              position: 'top',
              formatter: function (param) {
                // 因为柱状初始化为0，温度存在负值，所以，原本的0-100，改为0-130，0-30用于表示负值
                return param.value - 30 + '' + param.data.unit;
              },
              textStyle: {
                color: '#00F0FF',
                fontSize: '22',
                fontWeight: 'bolder',
              }
            }
          },
          z: 2
        }, {
          animation:false,
          name: '白框',
          type: 'bar',
          xAxisIndex: 1,
          barGap: '-100%',
          data: [129],
          barWidth: 8,
          itemStyle: {
            normal: {
              color: '#021A32',
              barBorderRadius: 50,
            }
          },
          z: 1
        }, {
          animation:false,
          name: '外框',
          type: 'bar',
          xAxisIndex: 2,
          barGap: '-100%',
          data: [130],
          barWidth: 12,
          itemStyle: {
            normal: {
              color: borderColor,
              barBorderRadius: 50,
            }
          },
          z: 0
        }, {
          animation:false,
          name: '圆',
          type: 'scatter',
          hoverAnimation: false,
          data: [0],
          xAxisIndex: 0,
          symbolSize: 18,
          itemStyle: {
            normal: {
              color: mercuryColor,
              opacity: 1,
            }
          },
          z: 2
        }, {
          animation:false,
          name: '白圆',
          type: 'scatter',
          hoverAnimation: false,
          data: [0],
          xAxisIndex: 1,
          symbolSize: 24,
          itemStyle: {
            normal: {
              color: '#021A32',
              opacity: 1,
            }
          },
          z: 1
        }, {
          animation:false,
          name: '外圆',
          type: 'scatter',
          hoverAnimation: false,
          data: [0],
          xAxisIndex: 2,
          symbolSize: 30,
          itemStyle: {
            normal: {
              color: borderColor,
              opacity: 1,
            }
          },
          z: 0
        }, {
          animation:false,
          name: '刻度',
          type: 'bar',
          yAxisIndex: 1,
          xAxisIndex: 3,
          label: {
            normal: {
              show: true,
              position: 'left',
              distance: 5,
              color: '#fff',
              fontSize: 10,
              formatter: function (params) {
                // 因为柱状初始化为0，温度存在负值，所以，原本的0-100，改为0-130，0-30用于表示负值
                if (params.dataIndex > 100 || params.dataIndex < 30) {
                  return '';
                } else {
                  if (params.dataIndex % 10 === 0) {
                    return params.dataIndex - 30;
                  } else {
                    return '';
                  }
                }
              }
            }
          },
          barGap: '-100%',
          data: kd,
          barWidth: 1,
          itemStyle: {
            normal: {
              color: borderColor,
              barBorderRadius: 10,
            }
          },
          z: 0
        }]
      };
    },
  },
}
</script>

<style scoped>

</style>
